// extracted by mini-css-extract-plugin
export default {"frame":"StoryPreview_frame__BaTlw","canvas":"StoryPreview_canvas__l-Qlo","picture":"StoryPreview_picture__I+YKX"};